import type { TTableReservationsMode } from '@/interfaces/IReservationSettings';

/** Shared shape for settings tables and the restaurant store's table list. */
export interface IReservationSetupTable {
  enabled: boolean;
  capacity: number;
  /** Older store rows omit this field and use the online default. */
  reservationsMode?: TTableReservationsMode;
}

export function isBookableReservationTable(
  table: IReservationSetupTable
): boolean {
  return (
    table.enabled && table.reservationsMode !== 'none' && table.capacity > 0
  );
}

/** Mirrors the API's audience rule: guests only ever see online tables. */
export function isOnlineReservationTable(
  table: IReservationSetupTable
): boolean {
  return table.enabled && (table.reservationsMode ?? 'online') === 'online';
}
